import type { ButtonConfig } from '../../declare'
import { useEffect, useRef, useContext } from 'react'
import { autorun, toJS } from 'mobx'
import { Button } from 'antd'
import { EasyIcon, FormPropsContext, ListPropsContext, ModalContext, postMsg } from 'src/components'
import { appStore, listStore } from 'src/stores'
import { $api, $consts } from 'src/plugins'
import { initFilter, getSingleRule, extendRules } from 'src/utils/common'

type Props = {
  config: ButtonConfig
}

const BatchSaveBtn = (props: Props) => {
  const formProps = useContext(FormPropsContext)
  const table = listStore.table.get(useContext(ListPropsContext).formCode)

  const modal = useContext(ModalContext)

  const fromEditHeader = useRef()
  const fromListHeader = useRef()
  useEffect(() => autorun(() => {
    const fromWhere = formProps.formData?.fromWhere

    const matchEditHeader = (
      fromWhere?.pageType === $consts['TABLE/FORM_TYPE_EDIT_PAGE']
      && fromWhere?.locateType === $consts['TABLE/BTN_LOCATE_HEADER']
      && fromWhere?.data
    )
    matchEditHeader && (fromEditHeader.current = matchEditHeader)

    const matchListHeader = (
      fromWhere?.pageType === $consts['TABLE/FORM_TYPE_LIST_PAGE']
      && fromWhere?.locateType === $consts['TABLE/BTN_LOCATE_HEADER']
      && fromWhere?.data
    )
    matchListHeader && (fromListHeader.current = matchListHeader)
  }), [])

  const handleSave = () => {
    const copyData = toJS(table.selectedData)
    if (!copyData.length) {
      postMsg('请选择需要批量新增的数据', 'error')
      return
    }

    // 编辑表单子表表头批量新增
    if (fromEditHeader.current) {
      modal?.close(copyData)
      return
    }

    const { API_URL, CUSTOM_PARAMS } = props.config
    if (!API_URL) {
      postMsg('没有配置保存接口', 'error')
      return
    }

    const { OrgId } = appStore.current.headers
    const payload = initFilter({ OrgId })
    extendRules(payload, [getSingleRule(CUSTOM_PARAMS, 1, copyData.map((item: any) => item.ID).join(','), true)])
    Object.assign(payload, fromListHeader.current)

    $api['app/getDataByPost'](payload, {
      url: API_URL
    }).then(res => {
      if (res) {
        postMsg('保存成功')
        modal?.close()
      }
    })
  }

  const { ICON } = props.config
  return (
    <Button
      type='primary'
      icon={<EasyIcon type={ICON} defaultIcon='SaveOutlined' />}
      onClick={handleSave}
    >保存</Button>
  )
}

export default BatchSaveBtn